import { render, staticRenderFns } from "./SalesLineDetail.vue?vue&type=template&id=3841bf10&"
import script from "./SalesLineDetail.vue?vue&type=script&lang=js&"
export * from "./SalesLineDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports